import { Params } from 'react-router';

import { IChannel } from '../channels/types';

export enum MimeType {
  SVG = 'image/svg+xml',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  WEBP = 'image/webp',
  BMP = 'image/bmp',
  TIFF = 'image/tiff',
  AVIF = 'image/avif',
}

export interface IImgUrlOptions {
  width: number;
  quality?: number;
  height?: number;
  fit?: ImageFit;
  position?: ImagePosition;
  contentType?: MimeType;
}

export type TUrlWithLocaleChannel = (
  params: Params,
  replacements?:
    | {
        locale?: string | undefined;
        channel?: IChannel | undefined;
      }
    | undefined
) => string;

export type TUrlWithLocaleChannelWithVars<TVars> = (
  params: Params,
  vars: TVars,
  replacements?:
    | {
        locale?: string | undefined;
        channel?: IChannel | undefined;
      }
    | undefined
) => string;

export type ImagePositionHorizontal = 'left' | 'center' | 'right';
export type ImagePositionVertical = 'top' | 'center' | 'bottom';
export type ImagePosition =
  | ImagePositionHorizontal
  | ImagePositionVertical
  | `${ImagePositionHorizontal} ${ImagePositionVertical}`;

export type ImageFit =
  /** Preserving aspect ratio, contain image within both provided dimensions using a border where necessary. */
  | 'contain'
  /** Preserving aspect ratio, ensure the image covers both provided dimensions by cropping it to fit. */
  | 'cover'
  /** Ignore the aspect ratio of the input and stretch to both provided dimensions. */
  | 'fill'
  /** Preserving aspect ratio, resize the image to be as large as possible while ensuring its dimensions are less than or equal to both those specified. */
  | 'inside'
  /** Preserving aspect ratio, resize the image to be as small as possible while ensuring its dimensions are greater than or equal to both those specified. */
  | 'outside';
